import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/market/[id]/IndexDetailClient.tsx");
